import React from 'react'

import FormControlLabel from '@mui/material/FormControlLabel'

import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import TextField from '@mui/material/TextField'
import FormControl from '@mui/material/FormControl'
import { ErrorMessage } from 'formik'
import errorIcon from 'images/error-icon.svg'
import { debounce } from '@mui/material'

// merge this w/ the impl in UserInfoForm. It assumes options are {label, value}
const FormikRadioGroup = ({ field, name, options, ...props }) => {
  const fieldName = name || field.name

  return (
    <React.Fragment>
      <RadioGroup {...field} {...props} name={fieldName}>
        {options.map((option, i) => (
          <FormControlLabel
            key={i}
            value={option.value}
            control={<Radio />}
            label={<span dangerouslySetInnerHTML={{ __html: option.label }} />}
          />
        ))}
      </RadioGroup>
    </React.Fragment>
  )
}

const FormikRadioGroup2 = ({
  onChange = function () {},
  defaultValue,
  value,
  name,
  options,
  setFieldValue,
}) => {
  return (
    <FormControl component="fieldset">
      <RadioGroup
        defaultValue={defaultValue}
        value={value}
        name={name}
        onChange={event => {
          setFieldValue(name, event.currentTarget.value)
          onChange(event)
        }}
      >
        {options.map((option, i) => (
          <FormControlLabel
            key={i}
            value={option.value}
            control={<Radio />}
            label={<span dangerouslySetInnerHTML={{ __html: option.label }} />}
          />
        ))}
      </RadioGroup>
    </FormControl>
  )
}

const lookupAddressDebounced = postalCode =>
  debounce((lookupAddress, formValues) => {
    lookupAddress({
      ...formValues,
      postalCode: postalCode,
    })
  }, 1000)

const ZipInput = props => {
  const errorExists = props.error || props.errors

  const handleOnZipChange = e => {
    console.log(e.target.current)
    props.form.setFieldValue(props.field.name, e.target.value)
    lookupAddressDebounced(e.target.value)(props.lookupAddress, props.values)
  }

  return (
    <FormControl
      className={`field field-${props.field.name}${props.index || ''}`}
      key={props.field.name}
    >
      <TextField
        error={props.error && props.form.isSubmitting && true}
        label={props.label}
        type={props.type}
        value={props.value || props.field.value}
        defaultValue={props.defaultValue}
        variant="filled"
        name={props.field.name}
        onChange={handleOnZipChange}
      />
      {errorExists && props.touched && (
        <div className="error">
          <ErrorMessage name={props.field.name} />
        </div>
      )}
      {errorExists && props.touched && (
        <img className="error-icon" src={errorIcon} alt="" />
      )}
    </FormControl>
  )
}

//note: when "type" of TextField is date, outputs "yyyy-mm-dd" as string. weirdly, this is actually the date type spec.
const renderTextInput = props => {
  return (
    <TextField
      required={props.required}
      autoComplete={props.autocomplete || props.autoComplete || 'on'}
      error={props.error && props.touched && true}
      helperText={
        props.error && props.touched && props.error === ' '
          ? 'This field is required.'
          : props.error
      }
      label={props.label}
      type={props.type}
      defaultValue={props.defaultValue}
      disabled={props.disabled}
      variant={props.variant || 'outlined'}
      name={props.field.name}
      value={props.value || props.field.value}
      fullWidth={props.fullWidth}
      onChange={e => props.form.setFieldValue(props.field.name, e.target.value)}
      InputLabelProps={
        props.shrink && {
          shrink: true,
        }
      }
    />
  )
}

//returns (###) ###-####
const renderSMSInput = props => {
  const formatPhoneNumber = input => {
    if (!input) {
      return input
    }
    input = input.replace(/\D/g, '')
    var size = input.length
    if (size > 0) {
      input = '(' + input
    }
    if (size > 3) {
      input = input.slice(0, 4) + ') ' + input.slice(4, 11)
    }
    if (size > 6) {
      input = input.slice(0, 9) + '-' + input.slice(9)
    }
    return input
  }
  return (
    <TextField
      required={props.required}
      autoComplete={props.autocomplete || props.autoComplete || 'on'}
      error={props.error && props.touched && true}
      helperText={
        props.error && props.touched && props.error === ' '
          ? 'This field is required.'
          : props.error
      }
      label={props.label}
      type={props.type}
      defaultValue={props.defaultValue}
      variant={props.variant || 'outlined'}
      name={props.field.name}
      value={props.value || props.field.value}
      onChange={e =>
        props.form.setFieldValue(
          props.field.name,
          formatPhoneNumber(e.target.value),
        )
      }
      InputLabelProps={
        props.shrink && {
          shrink: true,
        }
      }
    />
  )
}

const renderTextInput2 = props => {
  let name = props.name || props.field.name
  let inputLabelProperties = {}
  if (props.shrink) {
    inputLabelProperties.shrink = true
  }
  if (name) {
    inputLabelProperties.htmlFor = name
  }
  let autoComplete = props.field.autocomplete || props.autocomplete
  let inputProps = props.inputProps || {}
  inputProps.autoComplete = autoComplete || inputProps.autocomplete
  return (
    <TextField
      autoComplete={props.autocomplete || 'on'}
      error={props.error && props.touched && true}
      helperText={
        props.error && props.touched && props.error === ' '
          ? 'This field is required.'
          : props.error
      }
      label={props.label}
      type={props.type}
      defaultValue={props.defaultValue}
      variant={props.variant || 'outlined'}
      value={props.value || props.field.value}
      name={name}
      onChange={e => props.form.setFieldValue(props.field.name, e.target.value)}
      InputLabelProps={inputLabelProperties}
      inputProps={inputProps}
    />
  )
}

const stateOptions = [
  {
    text: 'Alabama',
    value: 'AL',
  },
  {
    text: 'Alaska',
    value: 'AK',
  },
  //TODO: this is racist
  // {
  //
  //   "text": "American Samoa",
  //   "value": "AS"
  // },
  {
    text: 'Arizona',
    value: 'AZ',
  },
  {
    text: 'Arkansas',
    value: 'AR',
  },
  {
    text: 'California',
    value: 'CA',
  },
  {
    text: 'Colorado',
    value: 'CO',
  },
  {
    text: 'Connecticut',
    value: 'CT',
  },
  {
    text: 'Delaware',
    value: 'DE',
  },
  {
    text: 'District Of Columbia',
    value: 'DC',
  },
  // {
  //   "text": "Federated States Of Micronesia",
  //   "value": "FM"
  // },
  {
    text: 'Florida',
    value: 'FL',
  },
  {
    text: 'Georgia',
    value: 'GA',
  },
  // {
  //   "text": "Guam",
  //   "value": "GU"
  // },
  {
    text: 'Hawaii',
    value: 'HI',
  },
  {
    text: 'Idaho',
    value: 'ID',
  },
  {
    text: 'Illinois',
    value: 'IL',
  },
  {
    text: 'Indiana',
    value: 'IN',
  },
  {
    text: 'Iowa',
    value: 'IA',
  },
  {
    text: 'Kansas',
    value: 'KS',
  },
  {
    text: 'Kentucky',
    value: 'KY',
  },
  {
    text: 'Louisiana',
    value: 'LA',
  },
  {
    text: 'Maine',
    value: 'ME',
  },
  // {
  //   "text": "Marshall Islands",
  //   "value": "MH"
  // },
  {
    text: 'Maryland',
    value: 'MD',
  },
  {
    text: 'Massachusetts',
    value: 'MA',
  },
  {
    text: 'Michigan',
    value: 'MI',
  },
  {
    text: 'Minnesota',
    value: 'MN',
  },
  {
    text: 'Mississippi',
    value: 'MS',
  },
  {
    text: 'Missouri',
    value: 'MO',
  },
  {
    text: 'Montana',
    value: 'MT',
  },
  {
    text: 'Nebraska',
    value: 'NE',
  },
  {
    text: 'Nevada',
    value: 'NV',
  },
  {
    text: 'New Hampshire',
    value: 'NH',
  },
  {
    text: 'New Jersey',
    value: 'NJ',
  },
  {
    text: 'New Mexico',
    value: 'NM',
  },
  {
    text: 'New York',
    value: 'NY',
  },
  {
    text: 'North Carolina',
    value: 'NC',
  },
  {
    text: 'North Dakota',
    value: 'ND',
  },
  // {
  //   "text": "Northern Mariana Islands",
  //   "value": "MP"
  // },
  {
    text: 'Ohio',
    value: 'OH',
  },
  {
    text: 'Oklahoma',
    value: 'OK',
  },
  {
    text: 'Oregon',
    value: 'OR',
  },
  // {
  //   "text": "Palau",
  //   "value": "PW"
  // },
  {
    text: 'Pennsylvania',
    value: 'PA',
  },
  // {
  //   "text": "Puerto Rico",
  //   "value": "PR"
  // },
  {
    text: 'Rhode Island',
    value: 'RI',
  },
  {
    text: 'South Carolina',
    value: 'SC',
  },
  {
    text: 'South Dakota',
    value: 'SD',
  },
  {
    text: 'Tennessee',
    value: 'TN',
  },
  {
    text: 'Texas',
    value: 'TX',
  },
  {
    text: 'Utah',
    value: 'UT',
  },
  {
    text: 'Vermont',
    value: 'VT',
  },
  // {
  //   "text": "Virgin Islands",
  //   "value": "VI"
  // },
  {
    text: 'Virginia',
    value: 'VA',
  },
  {
    text: 'Washington',
    value: 'WA',
  },
  {
    text: 'West Virginia',
    value: 'WV',
  },
  {
    text: 'Wisconsin',
    value: 'WI',
  },
  {
    text: 'Wyoming',
    value: 'WY',
  },
]

export {
  FormikRadioGroup,
  FormikRadioGroup2,
  renderTextInput,
  ZipInput,
  stateOptions,
  renderTextInput2,
  renderSMSInput,
}
